import { Skeleton } from '@reveni-io/reveni-ui'

const GiftCardBalanceSkeleton = () => <Skeleton variant="text" width="100%" height={20} />

export default GiftCardBalanceSkeleton
